<h1 matDialogTitle>Complete Survey Review</h1>

<mat-dialog-content>

  <!-- <optsol-ngx-dynamic-form [fields]="config.dynamicForm.formFields" [fxLayout]="config.dynamicForm.fxLayout" [fxLayoutAlign]="config.dynamicForm.fxLayoutAlign" [fxLayoutGap]="config.dynamicForm.fxLayoutGap"></optsol-ngx-dynamic-form> -->

  <div style="margin-bottom: 16px;padding: 8px;border-style: solid;border-radius: 5px;border-color: gray;border-width: 1px;font-size: 9pt;">
    <ng-container *ngFor="let question of config?.surveyResponses">
      <div class="question">
        {{question.title}}
      </div>
      <div class="response">
        {{question.answer}}
      </div>
    </ng-container>
  </div>

  <form [formGroup]="form">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="8px grid">

      <mat-form-field fxFlex="50">
        <mat-label>Order Type</mat-label>
        <input matInput type="text" formControlName="orderType" autocomplete="new-password" />
      </mat-form-field>

      <mat-form-field fxFlex="50">
        <mat-label>Order Number</mat-label>
        <input matInput type="text" formControlName="orderNumber" autocomplete="new-password" />
      </mat-form-field>

        <mat-form-field fxFlex="100">
          <mat-label>Branch / Store</mat-label>
          <input matInput type="text" formControlName="sysproBranch" autocomplete="new-password" />
        </mat-form-field>

      <mat-form-field fxFlex="100">
        <mat-label>Salesperson</mat-label>
        <input matInput type="text" formControlName="sysproSalesperson" autocomplete="new-password" />
      </mat-form-field>

      <mat-form-field [fxFlex]="100">
        <mat-label>Action Category</mat-label>
        <mat-select formControlName="actionCategoryId">
          <mat-option *ngFor="let action of config?.actionCategories" [value]="action.id">
            {{action.display}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field  [fxFlex]="100">
        <mat-label>Notes</mat-label>
        <textarea rows="5" #notes formControlName="salespersonNotes" matInput maxlength="200"></textarea>
        <mat-hint align="end"><span class="mobile-label-cell">{{notes.value.length}} / 200</span></mat-hint>
      </mat-form-field>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button [matDialogClose]="undefined">Cancel</button>
    <button mat-button [disabled]="!form.valid" (click)="save(false)">Save</button>
    <button mat-button [disabled]="!form.valid || !form.value.actionCategoryId" (click)="save(true)">Mark Complete</button>

</mat-dialog-actions>
